import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/styles';
import DetailItemLabel from './DetailItemLabel';

function ShippingDetailItemCard({ name, value }) {
	const theme = useTheme();

	return (
		<Grid item xs={12}>
			<DetailItemLabel label={name} />

			<Grid item xs={6} mt={-0.35}>
				{typeof value === 'string' ? (
					<Typography
						variant="caption1"
						tabIndex={0}
						aria-label={value}
						role="paragraph"
					>
						{value}
					</Typography>
				) : (
					value
				)}
			</Grid>
		</Grid>
	);
}

ShippingDetailItemCard.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
};

export default ShippingDetailItemCard;
